/* Matin (متين): pick the parent company's skin and build the login footer.
   Mirrors matin.brand.company_for_site — the first hostname label (ignoring
   "staging") starting with "eal" is EAL, with "meem" is MEEM, anything else RHQ. Runs
   on desk and website pages; the attribute drives the token sets in matin.css. */
(function () {
  // The login page's endorsement footer is rendered by matin/www/login.html since the
  // landing page (2026-09-26); this script keeps the skin attribute and the desk fixes.
  var COMPANIES = { rhq: { skin: "uem-edgenta" }, eal: { skin: "uem-blue" }, meem: { skin: "meem" } };

  function companyFor(host) {
    var labels = (host || "").toLowerCase().split(".").filter(function (l) { return l !== "staging"; });
    var first = labels[0] || "";
    if (first.indexOf("eal") === 0) return "eal";
    if (first.indexOf("meem") === 0) return "meem";
    return "rhq";
  }

  // The language switch, reachable from every screen (owner, 2026-09-26): the sidebar
  // menu, Frappe's navbar user menu (a Navbar Item with this action, matin.install) and
  // the Matin workspace's own top bar all call the same function.
  window.matin = window.matin || {};
  matin.other_language = function () {
    var current = ((window.frappe && frappe.boot && frappe.boot.lang) || document.documentElement.lang || "en");
    return current.indexOf("ar") === 0 ? "en" : "ar";
  };
  matin.language_label = function (lang) {
    return lang === "ar" ? "العربية" : "English";
  };
  matin.switch_language = function () {
    var other = matin.other_language();
    if (window.frappe && frappe.session && frappe.session.user && frappe.session.user !== "Guest") {
      frappe.xcall("matin.selfservice.set_language", { lang: other }).then(function () {
        window.location.reload();
      });
    } else {
      document.cookie = "preferred_language=" + other + ";path=/;max-age=31536000;SameSite=Lax";
      window.location.reload();
    }
  };

  var company = (window.frappe && frappe.boot && frappe.boot.matin_company) || companyFor(location.hostname);
  var brand = COMPANIES[company].skin;
  document.documentElement.setAttribute("data-brand", brand);


  // Desk: matin-home is the only home (owner decision 2026-09-24). Frappe's desktop is
  // replaced by it for everyone: reaching /desk (the sidebar's "Desktop" item, a bookmark)
  // redirects there without adding a history entry, and the breadcrumb's home icon and the
  // MATIN logo lead there instead of /desk.
  if (window.frappe && frappe.boot && frappe.boot.matin_cards) {
    var HOME = "/desk/matin-home";
    // Decide from the address, not frappe.get_route(): at app_ready the route is still null
    // (a crash here once stopped Frappe's own app_ready handlers and emptied the sidebar).
    var onDesktop = function () {
      var path = (window.location.pathname || "").replace(/\/+$/, "");
      // "" is the site root: Frappe serves the desk there for a signed-in desk user without
      // changing the address, and the desk router then shows Frappe's desktop.
      return ["", "/desk", "/app", "/desk/desktop", "/app/desktop"].indexOf(path) !== -1;
    };
    // A full load, not an in-app route: on /desk Frappe's desktop has already started
    // rendering when app_ready fires, and an in-app route left it on top of the card page
    // with the new address in the bar (found 2026-09-25).
    var goHome = function () {
      window.location.replace(HOME);
    };
    var patchBreadcrumbs = function () {
      if (!frappe.breadcrumbs || frappe.breadcrumbs.matin_patched) return;
      var clear = frappe.breadcrumbs.clear;
      frappe.breadcrumbs.clear = function () {
        var out = clear.apply(this, arguments);
        var home = document.querySelector('.navbar-breadcrumbs a[href="/desk"]');
        if (home) home.setAttribute("href", HOME);
        return out;
      };
      frappe.breadcrumbs.matin_patched = true;
    };
    var onRoute = function () {
      try {
        patchBreadcrumbs();
        if (onDesktop()) goHome();
      } catch (e) {
        // never let Matin's redirect break Frappe's own route / app_ready handlers
        if (window.console) console.warn("matin: home redirect skipped", e);
      }
    };
    // The sidebar header menu is hard-coded upstream (Desktop, Workspaces, Website, Edit
    // Sidebar, Session Defaults, Help ...). add_navbar_items runs inside the constructor
    // just before the menu is rendered, so wrapping it lets Matin replace the list: Home
    // (the card page) first, then only Display, Reload, Help and Logout. Help's own rows
    // (About, System Health, Frappe Support) are hidden in Navbar Settings by
    // matin.install; the Delete Demo Data row too.
    var DROP = { desktop: 1, workspaces: 1, website: 1, "edit-sidebar": 1 };
    var DROP_LABELS = { "Session Defaults": 1 };
    if (frappe.ui && frappe.ui.SidebarHeader) {
      var addNavbarItems = frappe.ui.SidebarHeader.prototype.add_navbar_items;
      frappe.ui.SidebarHeader.prototype.add_navbar_items = function () {
        var out = addNavbarItems.apply(this, arguments); // appends Navbar Settings rows
        var kept = [];
        (this.dropdown_items || []).forEach(function (item) {
          if (item.name && DROP[item.name]) return;
          if (item.label && DROP_LABELS[item.label]) return;
          if (item.hidden) return; // Navbar Settings rows hidden by matin.install
          if (item.is_divider && (!kept.length || kept[kept.length - 1].is_divider)) return;
          kept.push(item);
        });
        // The language switch (owner, 2026-09-26): English by default, Arabic a click
        // away; the choice is the user's own (User.language) and data entry stays English.
        var other = matin.other_language();
        kept.unshift(
          {
            name: "matin-home",
            label: __("Home"),
            icon: "home",
            onClick: function () {
              frappe.set_route("matin-home");
            },
          },
          {
            name: "matin-language",
            label: matin.language_label(other),
            icon: "globe",
            onClick: matin.switch_language,
          },
          { is_divider: true }
        );
        this.dropdown_items = kept;
        return out;
      };
    }
    $(document).on("app_ready", onRoute);
    if (frappe.router && frappe.router.on) frappe.router.on("change", onRoute);
    document.addEventListener("click", function (e) {
      var link = e.target.closest && e.target.closest('.navbar-brand, .navbar-home, a[href="/desk"]');
      if (!link || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      frappe.set_route("matin-home");
    });
  }

})();
